function coerceType(value: string): string | number | boolean {
  if (Number(value) > Number.MAX_SAFE_INTEGER) return '' + value
  if (parseFloat(value)) return parseFloat(value)
  if (value === 'true') return true
  if (value === 'false') return false
  return value
}

export function parseSettings(
  settings?: string,
  defaults: Record<string, string | number | boolean> = {}
): Record<string, string | number | boolean> {
  const result: Record<string, string | number | boolean> = {}
  if (typeof settings === 'string') {
    settings
      .split(';')
      .filter(pair => !!pair.trim())
      .forEach(pair => {
        const [key, val] = pair.split(':').map(s => s.trim())
        result[key] = val !== undefined && val !== '' ? coerceType(val) : true
      })
  }
  return Object.assign({}, defaults, result)
}
